(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("FEGOBridge"), require("FEGOWebapi"), require("VueDemi"), require("FEGORender"));
	else if(typeof define === 'function' && define.amd)
		define(["FEGOBridge", "FEGOWebapi", "VueDemi", "FEGORender"], factory);
	else if(typeof exports === 'object')
		exports["/fego/component/quotes-card-v3/render"] = factory(require("FEGOBridge"), require("FEGOWebapi"), require("VueDemi"), require("FEGORender"));
	else
		root["/fego/component/quotes-card-v3/render"] = factory(root["FEGOBridge"], root["FEGOWebapi"], root["VueDemi"], root["FEGORender"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__7145__, __WEBPACK_EXTERNAL_MODULE__5113__, __WEBPACK_EXTERNAL_MODULE__2309__, __WEBPACK_EXTERNAL_MODULE__5322__) => {
return 